var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForgotPasswordSent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 346,
    height: 170.23,
    viewBox: "0 0 346 170.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9089",
    "data-name": "Rectangle 9089",
    width: 346,
    height: 170.23,
    transform: "translate(3148 -13032)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_13287",
    "data-name": "Mask Group 13287",
    transform: "translate(-3148 13032)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e-mail",
    transform: "translate(3148 -13032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8462",
    "data-name": "Group 8462",
    transform: "translate(4.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20229",
    "data-name": "Path 20229",
    d: "M329.184,134.669c-2.09-22.531-10.888-39.7-33.763-52.28-6.709-3.719-15.177-5.469-19.136-12.031-3.959-6.453-2.529-14.765-3.3-22.312C270.9,28.688,252.309,13.7,232.843,11.626S194.021,18.3,179.174,31.094c-11.108,9.625-20.786,21.765-34.863,26.249-23.1,7.437-48.17-9.078-71.816-3.937C59.738,56.25,49.07,65.109,41.262,75.5c-13.087,17.39-16.277,39.374-12.318,60.7a71.859,71.859,0,0,0,15.177,32.593l274.5-.547C326.654,160.262,330.063,144.294,329.184,134.669Z",
    transform: "translate(-27.354 1.111)",
    fill: "#f2f7ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    cx: 21.194,
    cy: 21.194,
    r: 21.194,
    transform: "translate(83.984 6.479)",
    fill: "#f2f7ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_421",
    "data-name": "Ellipse 421",
    cx: 8.785,
    cy: 8.785,
    r: 8.785,
    transform: "translate(131.706)",
    fill: "#f2f7ff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_422",
    "data-name": "Ellipse 422",
    cx: 8.785,
    cy: 8.785,
    r: 8.785,
    transform: "translate(266.25 61.021)",
    fill: "#f2f7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8466",
    "data-name": "Group 8466",
    transform: "translate(89.836 25.148)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7459",
    "data-name": "Rectangle 7459",
    width: 121.675,
    height: 86.644,
    transform: "translate(0 58.113)",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8464",
    "data-name": "Group 8464",
    transform: "translate(10.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20232",
    "data-name": "Path 20232",
    d: "M228.312,51H205.8V30.467a7.467,7.467,0,0,1,14.935,0V44.3h0A7.622,7.622,0,0,0,228.312,51Z",
    transform: "translate(-105.429 -22.89)",
    fill: "#4f92ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20233",
    "data-name": "Path 20233",
    d: "M234.435,37.6v4.5a7.478,7.478,0,0,1-14.935.549Z",
    transform: "translate(-104.085 -21.457)",
    fill: "#d3dfff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20234",
    "data-name": "Path 20234",
    d: "M222.238,23.01H220.7a.4.4,0,0,0-.329.11c-.11,0-.329.11-.439.11s-.11,0-.22.11c-.11,0-.11.11-.22.11s-.22.11-.329.11-.22.11-.329.11h-.11c-.11,0-.11.11-.22.11a6.128,6.128,0,0,0-.879.549c-.11.11-.22.11-.22.22-.11.11-.22.11-.22.22-.11.11-.22.11-.22.22a4.777,4.777,0,0,0-.659.769c-.11.11-.22.22-.22.329a11.985,11.985,0,0,0-.659,1.208c0,.11-.11.22-.11.329l-.329.988a.4.4,0,0,1-.11.329c0,.22-.11.439-.11.769v105.2H114.4V34.65A11.763,11.763,0,0,1,126.15,22.9h96.088Z",
    transform: "translate(-114.4 -22.9)",
    fill: "#d3dfff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8463",
    "data-name": "Group 8463",
    transform: "translate(11.86 10.762)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7460",
    "data-name": "Rectangle 7460",
    width: 76.102,
    height: 3.953,
    fill: "#adc3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7461",
    "data-name": "Rectangle 7461",
    width: 70.172,
    height: 3.953,
    transform: "translate(0 11.75)",
    fill: "#adc3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7462",
    "data-name": "Rectangle 7462",
    width: 66.548,
    height: 3.953,
    transform: "translate(0 23.5)",
    fill: "#adc3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7463",
    "data-name": "Rectangle 7463",
    width: 76.102,
    height: 3.953,
    transform: "translate(0 35.251)",
    fill: "#adc3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7464",
    "data-name": "Rectangle 7464",
    width: 41.29,
    height: 3.953,
    transform: "translate(29.43 47.111)",
    fill: "#adc3ff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_20235",
    "data-name": "Path 20235",
    d: "M159.737,97.219a1.4,1.4,0,0,1-1.208-.549,2.97,2.97,0,0,1-.329-1.647l.439-10.323h.549l-.439,10.323c0,.439,0,.988.22,1.208.439.659,1.647.11,1.867,0a9.749,9.749,0,0,0,2.745-2.855,8.853,8.853,0,0,1,3.185-3.185,1.8,1.8,0,0,1,1.867.549c.329.22.549.439.769.549a3.8,3.8,0,0,0,2.2-.22,4.539,4.539,0,0,1,2.086-.22,4.852,4.852,0,0,1,1.757.659,3.573,3.573,0,0,0,2.416.439,16.523,16.523,0,0,0,3.734-1.757l.988-.659c1.318-.769,3.294-1.757,5.271-1.318l-.11.549c-1.757-.439-3.624.549-4.832,1.208l-.988.659a13.814,13.814,0,0,1-3.844,1.867,3.252,3.252,0,0,1-2.745-.549,6.35,6.35,0,0,0-1.537-.549,5.44,5.44,0,0,0-1.867.22,4.874,4.874,0,0,1-2.526.22,2.234,2.234,0,0,1-.988-.659c-.549-.439-.878-.659-1.318-.549a8.5,8.5,0,0,0-2.965,2.965,9.945,9.945,0,0,1-2.965,3.075A2.586,2.586,0,0,1,159.737,97.219Z",
    transform: "translate(-110.101 -16.835)",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20236",
    "data-name": "Path 20236",
    d: "M214.771,80.083v49.856H114.4V75.8l31.407,26.026a7.938,7.938,0,0,0,6.259,1.647,11.937,11.937,0,0,1,1.977-.11l21.414.549a14.883,14.883,0,0,1,2.2.22,8.225,8.225,0,0,0,6.369-1.318Z",
    transform: "translate(-114.4 -17.708)",
    fill: "#86a7ff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8465",
    "data-name": "Group 8465",
    transform: "translate(0 58.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20237",
    "data-name": "Path 20237",
    d: "M150.383,112.309l-.769.879-37.776,41.949-7.138,7.907V76.4Z",
    transform: "translate(-104.7 -76.4)",
    fill: "#4f92ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20238",
    "data-name": "Path 20238",
    d: "M219.593,76.4,173.8,112.309l45.793,50.734Z",
    transform: "translate(-97.918 -76.4)",
    fill: "#4f92ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20239",
    "data-name": "Path 20239",
    d: "M149.614,110.037l-37.776,41.839-7.138,1.537V138.04c18.888-13.507,40.082-29.211,44.914-29.54Z",
    transform: "translate(-104.7 -73.249)",
    fill: "#034aa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20240",
    "data-name": "Path 20240",
    d: "M174.6,110.037l37.776,41.839,7.138,1.537V138.04c-18.888-13.507-40.082-29.211-44.914-29.54Z",
    transform: "translate(-97.839 -73.249)",
    fill: "#034aa6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20241",
    "data-name": "Path 20241",
    d: "M226.375,159.991H104.7V148.571l41.949-38a11.984,11.984,0,0,1,8.017-3.075H176.08a12.157,12.157,0,0,1,7.907,2.965l42.5,37.666Z",
    transform: "translate(-104.7 -73.348)",
    fill: "#4f92ea"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7465",
    "data-name": "Rectangle 7465",
    width: 318.142,
    height: 0.549,
    transform: "translate(0 169.685)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35928",
    "data-name": "Path 35928",
    d: "M0,6.541S40.324-9.624,67.431,8.871c37.881,25.849,30.505,71.265,19.6,79.221s-24.1-5.671-9.959-18.661c13.8-12.674,38.545-12.364,50.605,7.524s2.161,44.191,30.534,53.717",
    transform: "matrix(-0.342, 0.94, -0.94, -0.342, 320.661, 66.257)",
    fill: "none",
    stroke: "#034aa6",
    strokeMiterlimit: 10,
    strokeWidth: 0.75,
    strokeDasharray: "4 5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13524",
    "data-name": "Group 13524",
    transform: "translate(292.884 20.523)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_423",
    "data-name": "Ellipse 423",
    cx: 21.975,
    cy: 21.975,
    r: 21.975,
    fill: "#5b4dad",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8469",
    "data-name": "Group 8469",
    transform: "translate(6.593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8467",
    "data-name": "Group 8467"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_424",
    "data-name": "Ellipse 424",
    cx: 21.975,
    cy: 21.975,
    r: 21.975,
    fill: "#feaf43"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "paper-plane",
    transform: "translate(14.863 10.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20243",
    "data-name": "Path 20243",
    d: "M8.75,17.612v4.552a.736.736,0,0,0,1.329.436l2.663-3.623Z",
    transform: "translate(-0.163 -0.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20244",
    "data-name": "Path 20244",
    d: "M23.245.136a.736.736,0,0,0-.767-.053L.4,11.615a.736.736,0,0,0,.1,1.349l6.139,2.1L19.71,3.884,9.593,16.073l10.288,3.516a.753.753,0,0,0,.238.039A.735.735,0,0,0,20.847,19L23.546.845a.737.737,0,0,0-.3-.709Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPasswordSent);
export default __webpack_public_path__ + "static/media/forgot-password-sent.042aeb7b88a6c83c9a649e6fba84e926.svg";
export { ForwardRef as ReactComponent };